function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-name": "Path 12057",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.987 262.146h4.884l-1.08-1.162a.77.77 0 1 1 1.1-1.027l2.332 2.394a.766.766 0 0 1-.082 1.14l-2.271 2.425a.77.77 0 0 1-1.109-1.027l1.08-1.162H125a.775.775 0 1 1-.021-1.54z",
    style: {
      fill: "#892461"
    },
    transform: "rotate(-90 -54.398 188.836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.861 3.917h4.883l-1.08 1.162a.77.77 0 1 0 1.1 1.027l2.331-2.394a.766.766 0 0 0-.082-1.139L5.742.148a.77.77 0 0 0-1.109 1.026l1.08 1.162H.871a.775.775 0 1 0-.021 1.54z",
    "data-name": "Undo",
    style: {
      fill: "#892461"
    },
    transform: "rotate(90 4.309 18.52)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10",
    "data-name": "Line 467",
    style: {
      stroke: "#892461",
      strokeLinecap: "round",
      strokeWidth: "1.8px",
      fill: "none"
    },
    transform: "translate(2.5 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10",
    "data-name": "Line 466",
    style: {
      stroke: "#892461",
      strokeLinecap: "round",
      strokeWidth: "1.8px",
      fill: "none"
    },
    transform: "translate(2.5 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10",
    "data-name": "Line 465",
    style: {
      stroke: "#892461",
      strokeLinecap: "round",
      strokeWidth: "1.8px",
      fill: "none"
    },
    transform: "translate(2.5 9)"
  })));
};
export default SvgExpand;